console.log("custom js working");

//testimonial slider functionality
$(document).ready(function () {
  $(".testimonial-slider").slick({
    adaptiveHeight: true,
    autoplay: true,
    sdots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: "linear",
    arrows: true,
    pauseOnHover: true,
  });
});

// Product slider functionality

$(document).ready(function () {
  $(".product-slider-slick").slick({
    autoplay: true,
    dots: true,
    dotsClass: "custom-dots",
    fade: true,
    infinite: true,
    fade: true,
    cssEase: "linear",
    arrows: false,
    pauseOnHover: true,
    pauseOnDotsHover: true,
    mobileFirst: true,
  });
});

// Features mobile slider functionality
$(document).ready(function () {
  $(".slider-inner").slick({
    adaptiveHeight: true,
    autoplay: true,
    dots: true,
    dotsClass: "custom-dots",
    fade: true,
    infinite: true,
    fade: true,
    cssEase: "linear",
    arrows: true,
    pauseOnHover: true,
    pauseOnDotsHover: true,
    mobileFirst: true,
  });
});

// console.log(screen.availWidth);

var toggelIcon = document.querySelector(".mobile-menu__toggle-icon");

toggelIcon.addEventListener("click", () => {
  if (toggelIcon.classList.contains("is-active")) {
    toggelIcon.classList.remove("is-active");
    // console.log("close");
  } else {
    toggelIcon.classList.add("is-active");
    // console.log("open");
  }
});

var searchIcon = document.getElementById("search-icon");

searchIcon.addEventListener("click", () => {
  document.querySelector(".mobile-search").style.display = "block";
});
var closeSearch = document.querySelector(".close-search");

closeSearch.addEventListener("click", () => {
  document.querySelector(".mobile-search").style.display = "none";
});

// toggelIcon.classList.add("is-active");

// Add some code to have external links open in a new browser tab

var links = document.querySelectorAll(
  ".header__menu-items a, .footer__block .footer__menu a"
);
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].relList.add("noreferrer", "noopener");
  }
}
